import template from './teamRequestsModalApproveAll.html';
import controller from './teamRequestsModalApproveAll.controller';
import './teamRequestsModalApproveAll.scss';

let teamRequestsModalApproveAllComponent = {
  restrict: 'E',
  bindings: {
    onApproveAll: '&',
    success: '<',
    error: '<',
    isMobileApp: '<'
  },
  template,
  controller
};

export default teamRequestsModalApproveAllComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamRequests/teamRequestsModalApproveAll/teamRequestsModalApproveAll.component.js